import { render, staticRenderFns } from "./nearexpiration.vue?vue&type=template&id=4ca91d06&"
import script from "./nearexpiration.vue?vue&type=script&lang=js&"
export * from "./nearexpiration.vue?vue&type=script&lang=js&"
import style0 from "./nearexpiration.vue?vue&type=style&index=0&id=4ca91d06&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports